/* eslint-disable */

export default {
  "signup": {
    "title": "Crear cuenta nueva",
    "subtitle": "Iniciar sesión",
    "tos": "Estoy de acuerdo con los términos de servicio de RELE.AI",
    "privacy": "Acepto los términos de privacidad de RELE.AI",
    "chooseMethod": "Crear cuenta nueva",
    "provideNumberDescription": "Hola 👋<br />Por favor, facilita tu número móvil para poder acceder a RELE.AI, tu asistente de CRM.",
    "createOrganizationDescription": "Por favor, nombra tu Compañia.<br />Una vez creada, podrás conectar tu CRM e invitar a miembros de tu equipo.",
    "firstIntegrationDescription": "Conecta a RELE.AI con una de las integraciones abajo. Siempre puedes cambiar o añadir más integraciones luego en la página de integraciones."
  },
  "globals": {
    "search": "Buscar...",
    "hi": "Hola,",
    "contactClara": "Contacta a RELE.AI",
    "page": "Pagina",
    "month": "Mes",
    "year": "Año"
  },
  "payments": {
    "yearly": "Plan Anual",
    "monthly": "Plan Mensual",
    "small": "Estándar",
    "enterprise": "Enterprise",
    "smallDescription": "Pequeña o Mediana empresa?<br />Este plan incluye hasta 100 usuarios",
    "enterpriseDescription": "Más de 100 usuarios? <br/> Pongámonos en contacto...",
    "planLayout_monthly": "mensual/usuario",
    "planLayout_yearly": "anual/usuario",
    "welcome": "¡Que emocion tenerte con nosotros! 🥳<br /><br />Si necesitas ayuda, contactanos a <a href='mailto:support@rele.ai' class='text-r-primary'>support@rele.ai</a>",
    "errorOnCheckout": "Algo salió mal mailto:support@rele.ai<br /><br /> Nos encantará ayudarte, sólo envíanos un correo electrónico a <a href='support@rele.ai' class='text-r-primary'>😕</a>",
    "activeSubscription": {
      "dialogs": {
        "update": {
          "title": "Cambiar el plan de suscripción",
          "description": "RELE.AI ofrece planes mensuales y anuales que pueden verse en nuestra página de precios <a href=\"https://rele.ai/pricing/\" target=\"_blank\" about class=\"text-r-primary\">precios.</a><br />Si deseas cambiar de plan, sólo selecciona el plan que quieras de la lista desplegable y haz clic en Guardar.",
          "plans": "Planes"
        },
        "delete": {
          "title": "Cancelar suscripción",
          "description": "<div class=\"font-semibold\">No queremos que vayas a 😢</div><br />¿Estás seguro qué quieres cancelar tu suscripción?<br />Hablemos primero <a href='mailto:support@rele.ai' class=\"text-r-primary\">support@rele.ai</a>"
        }
      },
      "invoices": {
        "title": "Facturas",
        "created": "Fecha de factura",
        "amountPaid": "Cantidad pagada",
        "invoicePdf": "Descargar factura",
        "emptyItems": "No hay facturas todavía"
      },
      "subscriptionInfo": {
        "title": "Detalles de la suscripción",
        "startDate": "Fecha de inicio",
        "plan": "Plan",
        "price": "{amount} {currency}/usuario/{interval}",
        "amountOfUsers": "Número de usuarios"
      }
    }
  },
  "usersManagement": {
    "user": "Usuario",
    "table": {
      "name": "Nombre de Empleado",
      "email": "Correo Electronico",
      "phone": "Telefono móvil",
      "actions": "Acciones",
      "title": "Manejo de usuarios",
      "addNew": "Agregar usuario"
    },
    "deleteDialog": {
      "title": "Eliminar usuario",
      "description": "Estas seguro que quieres eliminar a {name}?"
    }
  },
  "activeIntegrations": {
    "integration": "Integración",
    "table": {
      "title": "Integraciones Activas",
      "noIntegrations": "Oops!<br /> No tienes ninguna integración activa.<br /> Por favor, habilita una de las integraciones y empieza a documentar."
    }
  },
  "nonActiveIntegrations": {
    "title": "Mercado",
    "description": "Para habilitar una de las integraciones, haz clic en la integración y sigue las instrucciones.",
    "hubspot": {
      "title": "Integración de Hubspot",
      "description": "Integra tu cuenta de Hubspot."
    },
    "salesforce": {
      "title": "Integración de Salesforce",
      "description": "Integra tu cuenta de Salesforce."
    },
    "mailing": {
      "title": "Integración de correo electronico",
      "description": "Integra tu cuenta de correo electronico."
    },
    "noIntegrations": "¡Felicidades! <br /> Has activado todas las integraciones."
  },
  "integrations": {
    "table": {
      "title": "Integraciones"
    },
    "crm": {
      "giveCarlaAccess": "Para conectar a RELE.AI por favor sigue estos pasos",
      "title": "Integraciones de CRM",
      "noCrmConnections": "Todavía no le has dado a RELE.AI acceso a tu CRM.",
      "connectCrm": "Conectar CRM",
      "apiKey": "Clave API:",
      "updateConnection": "Edita",
      "selectCRM": "Selecciona un CRM",
      "salesforce": {
        "guide": "<ol class=\"list-decimal\"><li>Conéctate en Salesforce cliqueando en el botón de abajo</li><li>Aprobar el acceso a RELE.AI</li></ol>",
        "releaiPackage": "<div>• Antes de la iniciar sesión con Salesforce, debe vincular su cuenta de Salesforce con la aplicación RELE.AI Salesforce.<br /><div style='margin-top: 10px;'>• Compruebe con su administrador de Salesforce que la aplicación ya está instalada. Si no está instalada, puede hacerlo haciendo clic <a style='color: blue;' href=\"https://login.salesforce.com/packaging/installPackage.apexp?p0=04t3z000001zs7p\" target=\"_blank\">aquí</a>.</div><div style='margin-top: 10px;'>• Para más información: <a style='color: blue;' href=\"https://rele.ai/how-to-connect-salesforce/\" target=\"_blank\">https://rele.ai/how-to-connect-salesforce</a></div></div>"
      },
      "hubspot": {
        "chooseAuth": {
          "oauth": "Enlace con hubspot",
          "apiKey": "Clave API",
          "title": "Elige el método de autenticación",
          "chooseAuthMethodTitle": "¿Qué método de autentificación de HubSpot debería elegir?",
          "chooseAuthApiKeyDesc": "<div>Conectarse a HubSpot mediante una llave API dará permiso a todos los usuarios que añada en la consola RELE.AI para acceder a HubSpot a través de RELE.AI.</div>",
          "chooseAuthOauthDesc": "<div>Si se conecta a HubSpot utilizando el método de inicio de sesión (login) con HubSpot, sólo se dará permiso a su usuario para acceder HubSpot a través de RELE.AI.</div>",
          "description": "Por favor, selecciona tu conexión con hubspot. Puedes elegir entre conectarte con la clave de la API de tu cuenta de hubspot o con el enlace de OAuth.",
          "tooltips": {
            "oauth": "<div>Tenga en cuenta que debe informar a los miembros de su equipo (usuarios de RELE.AI) que deben seguir estos pasos:<br />1. Visitar <a href=\"https://console.rele.ai\" target=\"_blank\" about class=\"text-r-primary\">https://console.rele.ai</a> <br />2. Visitar la sección de integraciones <br />3. Seleccione HubSpot <br />4. Ingresa con el login de HubSpot</div>"
          }
        },
        "guideOauth": "<ol class=\"list-decimal\"><li>Conéctate a Hubspot cliqueando en el botón de abajo</li><li>Aprobar el acceso a RELE.AI</li></ol>",
        "guideApiKey": "<ol class=\"list-decimal\"><li>Entra a tu cuenta de HubSpot</li><li>Accede a la configuración de HubSpot haciendo clic en tu Perfil -> Perfil y preferencias</li><li>En el menú de la izquierda ve a Integraciones -> API key</li><li>Copia la clave API y pégala en la entrada de abajo</li></ol>",
        "docs": {
          "part1": "¿No la encontraste? Por favor, visita",
          "link": "este",
          "part2": "enlace para mayor explicación"
        }
      },
      "deleteDialog": {
        "title": "Eliminar la integración",
        "description": "¿Estás seguro de que quieres eliminar la integración de {name}?"
      }
    },
    "mailing": {
      "guide": "Permite el acceso para enviar correos electrónicos haciendo clic en la casilla de verificación.",
      "checkbox": {
        "enable": "El correo electrónico está activado.",
        "disable": "El correo electrónico está desactivado",
        "disableInfo": "Por favor, añade una dirección de correo electrónico para activar la función de correo electrónico."
      }
    }
  },
  "notifications": {
    "trailEndIn": "Tu periodo de prueba termina en {days}. Por favor, completa la información de pago. 🤑",
    "editSuccess": "¡Felicidades! Acabas de actualizar {name}.",
    "createSuccess": "¡Felicidades! Acabas de crear {name}."
  },
  "forms": {
    "firstname": "Primer Nombre",
    "lastname": "Apellido",
    "email": "Correo Electrónico",
    "mobile": "Teléfono móvil",
    "workspace": "Nombre de la Compañia",
    "botLang": "Idioma preferido del robot",
    "claraNumber": "Número de bot preferido",
    "password": "Contraseña"
  },
  "buttons": {
    "continueWithGoogle": "Continúa con Google",
    "continueWithMicrosoft": "Continúa con Microsoft",
    "next": "Siguiente",
    "back": "Regreso",
    "getStarted": "Siguiente",
    "edit": "Editar",
    "save": "Guardar",
    "delete": "Eliminar",
    "cancel": "Cancelar",
    "signOut": "Cerrar sesión",
    "continueWithSalesforce": "Continuar con Salesforce",
    "continueWithHusbpot": "Continuar con Hubspot",
    "botSettings": "Ajustes del Bot",
    "consoleSettings": "Ajustes del Console",
    "close": "Cerrar",
    "continueWithEmail": "Continuar con Correo Eletrónico",
    "cancelSubscription": "Cancelar suscripción",
    "changePlan": "Cambiar el plan",
    "deleteCompany": "borrar la compañía"
  },
  "errors": {
    "unableToAuthenticateTitle": "Incapaz de completar la autenticación",
    "missingRequiredField": "No es posible completar la autenticación",
    "unableToCreateUser": "No es posible crear un usuario",
    "workspaceNameRequired": "El nombre de la Compañia es requerido",
    "unableToCreateNewOrg": "No se pudo crear la Compañia",
    "unableToUpdateUserWithOrgId": "No se puede adjuntar el usuario a la Compañia",
    "validateEmail": "Dirección de correo electrónico inválida. Por favor, introduzca una dirección de correo electrónico válida.",
    "validateFirstName": "Nombre inválido. No introduzca espacios o caracteres especiales.",
    "validateLastName": "Apellido inválido. No introduzca espacios o caracteres especiales.",
    "unableToDeleteUser": "No se pudo eliminar el usuario",
    "unableToLoginWithSalesforce": "No se pudo iniciar sesión con Salesforce.",
    "unableToLoginWithHubspot": "No se pudo iniciar sesión con HubSpot.",
    "unableToEnableMailing": "Función de correo electrónico no activada.",
    "unableToCreatePaymentSubscription": "No se pudo hacer el pago.",
    "unableToDeleteIntegration": "No se pudo eliminar la integrasion",
    "unableToSaveBotSettings": "No se pudo guardar la configuración del Bot.",
    "unableToChangeSubscription": "No se pudo cambiar el plan de suscripción.",
    "unableToCancelSubscription": "No se pudo cancelar la suscripción. Por favor, contacta a nuestro equipo de servicio al cliente.",
    "validateMobile": "Hay un usuario existente con el mismo número."
  },
  "placeholders": {
    "enterYourEmail": "Escribe tu correo electrónico",
    "enterYourPassword": "Escribe tu contraseña."
  },
  "botOptions": {
    "inherit": "Idioma predeterminado de la Compañia",
    "en": "Ingles",
    "es": "Español",
    "fr": "Frances",
    "gr": "Aleman",
    "pt": "Portugués"
  },
  "botSettings": {
    "title": "Configuración del robot"
  },
  "deleteCompany": "borrar la compañía"
}